import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import {  TEXT_FIELDS } from '../../customer-service.service';
import Swal from 'sweetalert2';
import { SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';

@Component({
  selector: 'app-business-contacts-details',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgSelectModule, ManageTemplateComponent],
  templateUrl: './business-contacts-details.component.html',
  styleUrls: ['./business-contacts-details.component.scss']
})

export class BusinessContactsDetailsComponent implements OnInit {
  previousNetworks: any[] = [];
  fields : Array<Partial<TEXT_FIELDS>>;
  columns : Array<Partial<TEXT_FIELDS>>;
  businessContactDetails !: any;
  userDatas = new BehaviorSubject([]);
  noNetworkSelected: boolean = false;
  businessNetworkId: any;
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  payload = {
    limit: 10,
    page: 1,
    searchContent : null,
    status : null,
    searchAfterKey : null
  }
  businessData: any;
  selectedNetwork = new FormControl(null , [Validators.required]);
  selectedBusinessType;
  subContractAllowed: boolean = false;
  peerContactType: string = null;
  b2bNetworkList=[]
  b2bNetworkListFull=[]
  businessTypeList = [
    {
      label : 'Client'
    },
    {
      label : 'Supplier'
    },
    {
      label : 'Customer/Supplier'
    },
   ];


  beingRemoved: boolean = false;
  constructor(private API: ApiService, private _activated_route: ActivatedRoute,
    private util : UtilService
  ) {

     this.fields = [
      {label : "Business ID" , key : 'platformBusinesId' , disabled : true},
      {label : "Business Name" , key : "businessName" , disabled : true},
      {label : "Business Type" , key : "typeLabel" , disabled : true},
      {label : "Network" , key : "network" , dropdownView : true , disabled : false},
      {label : 'Sub-Contract', key : 'subContractAllowed', dropdownView : true, disabled : false},
      {label : "Owner" , key : "owner" , disabled : true},
      {label : "Role" , key : "role" , disabled : true},
      {label : "Email" , key : "businessEmail" , disabled : true},
     ];

     this.columns = [
      {label : 'Members' , key : 'fullname'},
      {label : 'Email' , key : 'email'},
      {label : 'Title' , key : 'title'},
     ];



     this._activated_route.queryParams.subscribe(res => {
      this.businessData = res;
     });


   }

  ngOnInit(): void {
    if (this.businessData.contactBusinessId) {
      this.getBusinessUserNetworkMembers();
      this.loadB2bNetworks();
      this.loadB2BContact();
    }
  }

  loadB2BContact() {
    this.API.query(`business/getB2BContact/${this.businessData.id}/${this.businessData.contactBusinessId}`)
      .subscribe(response => {
        if (response?.code === GigsumoConstants.SUCESSCODE && response.data?.b2bContact) {
          const contact = response.data.b2bContact;
          // Sub-contracting is decided by the CLIENT only, so read the governing flag by direction —
          // NOT the raw subContractAllowed. For requestType=Supplier the peer is the Client, so the
          // decision lives in peerSubContractAllowed; the Supplier's own subContractAllowed stays null
          // (which is why reading it directly showed the toggle OFF even when the Client allowed it).
          this.subContractAllowed = (
            ((contact.requestType || '').toLowerCase() === 'supplier')
              ? contact.peerSubContractAllowed
              : contact.subContractAllowed
          ) ?? false;
        }
      });
  }



  confirmNetworkChange() {
    if (this.businessContactDetails.connectionStatus === 'REQUEST_RECEIVED') {
      return;
    }
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    const newNetworks = this.selectedNetwork.getRawValue();
    if (!newNetworks || newNetworks.length === 0) {
      this.noNetworkSelected = true;

      swalWithBootstrapButtons.fire({
        title: `At least one network is required`,
        icon: 'warning',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Ok',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.selectedNetwork.patchValue(this.previousNetworks);
        }
      });
      return;
    }
    this.noNetworkSelected = false;
    if (JSON.stringify(this.previousNetworks) !== JSON.stringify(newNetworks)) {
      swalWithBootstrapButtons.fire({
        title: 'Are you sure you want to edit the network?',
        icon: 'warning',
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          const data = { ...this.businessContactDetails };
          data.businessNetworks = newNetworks;
          data.peerBusinessId = this.businessData.id;
          this.updateBusinessNetwork(data);
        } else {

          this.selectedNetwork.patchValue(this.previousNetworks);
        }
      });
    }
  }


  updateBusinessNetwork(event) {
    const data = structuredClone(event);
    data.b2bNetworks = this.selectedNetwork.getRawValue();
    data.contactType = data.type;
    data.contactStatus =data.connectionStatus=='REQUEST_SENT'?'PENDING':data.connectionStatus;
    data.businessId = this.businessData.id;
    data.peerBusinessId = this.businessData.contactBusinessId;

    this.API.create('business/editB2BContact', data).subscribe(res => {
      if (res && res.code === '00000') {
        Swal.fire({
          icon: "success",
          title: 'Business Updated!',
          text: 'Business updated successfully',
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 1000,
        });
        this.previousNetworks = [...this.selectedNetwork.getRawValue()];
      }
      this.util.stopLoader();
    });
  }

  loadB2bNetworks() {
      this.API.create('business/findB2BNetworks',
        {
          businessId: this.businessData.id,
         "limit":50
       }).subscribe(response=>{

          if(response.code === GigsumoConstants.SUCESSCODE){
            // Keep the full list; the dropdown is filtered by the selected Business Type.
            this.b2bNetworkListFull = [...this.b2bNetworkListFull, ...response.data.b2bNetworks];
            this.applyNetworkFilter();
          }
       });
  }

  // Business Type -> allowed network types.
  //  Client            -> Client networks
  //  Supplier          -> Supplier networks
  //  Client/Supplier   -> General (N/A) + Client/Supplier networks
  //  N/A / other       -> handled separately, no filtering applied here
  private normalizeBusinessType(t: string): string {
    return t === 'Customer/Supplier' ? 'Client/Supplier' : t;
  }

  // Read-only display mapping for the Business Type field. Backend stores the
  // canonical "Client_Supplier"; the UI must show "Client/Supplier" (matches the
  // networkTypeLabel pipe used on the listing). Never changes the stored value.
  private formatBusinessType(type: string): string {
    if (!type) { return 'N/A'; }
    if (type.trim().toLowerCase() === 'client_supplier') { return 'Client/Supplier'; }
    return type === 'Customer/Supplier' ? 'Client/Supplier' : type;
  }

  private applyNetworkFilter(): void {
    const all = this.b2bNetworkListFull || [];
    const bt = this.normalizeBusinessType(this.selectedBusinessType);
    if (!bt) {
      // No Business Type yet -> nothing to pick and the dropdown stays disabled.
      this.b2bNetworkList = [];
      if (this.selectedNetwork.enabled) { this.selectedNetwork.disable(); }
      return;
    }
    if (bt === 'Client') {
      this.b2bNetworkList = all.filter(n => n.type === 'Client');
    } else if (bt === 'Supplier') {
      this.b2bNetworkList = all.filter(n => n.type === 'Supplier');
    } else if (bt === 'Client/Supplier') {
      // backend canonical network type is 'Client_Supplier'; 'N/A' + slash kept for legacy rows
      this.b2bNetworkList = all.filter(n => n.type === 'N/A' || n.type === 'Client_Supplier' || n.type === 'Client/Supplier');
    } else {
      this.b2bNetworkList = all;
    }
    if (this.selectedNetwork.disabled) { this.selectedNetwork.enable(); }
  }


  getBusinessUserNetworkMembers() {
    this.util.startLoader();
    this.API.create('business/findB2BContactDetails',
      {
        businessId: this.businessData.contactBusinessId,
        peerBusinessId : this.businessData.id,
        ...this.payload

      }).subscribe(response => {
        this.util.stopLoader();
      if (response.code === AppSettings.SUCESS_CODE) {
        const b2bContactEmployees = response.data.mappedEmployeesList;
        const searchKey = response.data.searchAfterKey;

        if (b2bContactEmployees) {
          const current = b2bContactEmployees;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(b2bContactEmployees != null && (b2bContactEmployees.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }

        this.prevSearchAfterKey =  searchKey;
        const { userData , ...rest } = response.data.businessModel;
        let data = {
          ...rest,
          // Read-only display of the business type (canonical "Client_Supplier" -> "Client/Supplier").
          typeLabel : this.formatBusinessType(rest.type),
          owner : userData.firstName + " " + userData.lastName,
          members: rest.membersCount,
          userId : userData.userId,
          role : 'Super Admin',
        }
        this.businessContactDetails = data;
        this.selectedBusinessType = this.businessContactDetails.type;
        this.peerContactType = this.businessContactDetails.peerContactType || null;
        this.applyNetworkFilter();
        this.selectedNetwork.patchValue(this.businessContactDetails.businessNetworks);
        this.previousNetworks = [...this.businessContactDetails.businessNetworks];
      }
    });

  }

  updateBusinessNetworkMembers(members: any) {
    const userData = members.value;
    let data = {
      peerBusinessId: this.businessData.id,
      businessId: this.businessData.contactBusinessId,
      userId: userData.userId,
      status: userData.userStatus === "CONNECTED" ? "ACTIVE" : userData.userStatus
    }
    if(members.checked){
       this.updateMembersbulk(data);
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        allowOutsideClick : false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        title : "Inactive Employee From Business",
        text : `Are you sure you want to inactive ${userData.firstName}?`
      }).then(res=>{

        this.util.startLoader();
        const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

        if(res.isConfirmed){
          this.updateMembersbulk(data);
          this.util.stopLoader();
        }
        else{
          updatedData.forEach(res=>{
            if(res.userId === userData.userId){
              res.userStatus = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
          this.util.stopLoader();
        }



      });


    }

  }


  updateMembersbulk(data){
    this.util.startLoader();
    this.API.create('business/editB2bEmployee', data).subscribe(res => {
      this.util.stopLoader();
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Member Updated!',
          text : 'Member updated successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userDatas.next([]);
          this.getBusinessUserNetworkMembers();
        }, 1000);
      }
    });
  }
  onSearch(value , obj : BusinessContactsDetailsComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onFilter(data , obj : BusinessContactsDetailsComponent){

    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;

    obj.userDatas.next([]);
    obj.getBusinessUserNetworkMembers();
  }

  onScroll(obj : BusinessContactsDetailsComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getBusinessUserNetworkMembers();
    }
  }

  onSubContractToggle(): void {
    if ((this.selectedBusinessType !== 'Supplier' && this.selectedBusinessType !== 'Customer/Supplier') ||
        this.businessContactDetails?.connectionStatus !== 'CONNECTED') {
      return;
    }

    const newValue = !this.subContractAllowed;
    const action = newValue ? 'enable' : 'disable';

    Swal.fire({
      title: `Are you sure you want to ${action} sub-contracting?`,
      text: newValue
        ? 'This will allow the supplier to sub-contract your jobs to their network.'
        : 'This will prevent the supplier from sub-contracting your jobs.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.subContractAllowed = newValue;
        const data = { ...this.businessContactDetails };
        data.subContractAllowed = newValue;
        data.peerBusinessId = this.businessData.id;
        this.updateBusinessNetwork(data);
      }
    });
  }

  onTypeChange(): void {
    if (this.businessContactDetails.connectionStatus === 'REQUEST_RECEIVED'
      || this.businessContactDetails.connectionStatus === 'CONNECTED') {
      return;
    }

    // Reciprocal type validation
    if (this.peerContactType && this.selectedBusinessType !== 'N/A'
        && this.selectedBusinessType !== 'Customer/Supplier'
        && this.selectedBusinessType === this.peerContactType) {
      const reciprocal = this.selectedBusinessType === 'Client' ? 'Supplier' : 'Client';
      Swal.fire({
        title: 'Invalid Type Selection',
        text: `This contact is already classified as "${this.selectedBusinessType}" on their end. Please select "${reciprocal}", or create a separate connection profile for a ${this.selectedBusinessType} relationship.`,
        icon: 'warning',
        confirmButtonText: 'OK',
      }).then(() => {
        this.selectedBusinessType = this.businessContactDetails.type;
      });
      return;
    }

    // Business Type changed -> re-scope the network dropdown to the matching types.
    this.applyNetworkFilter();

    let data = this.businessContactDetails;
    data.type = this.selectedBusinessType;
    data.peerBusinessId = this.businessData.id;
    this.updateBusinessNetwork(data);
  }


}
